import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from 'components/FormError';
import CheckboxField from 'components/CheckboxField';
import PurchaseItemList from 'components/PurchaseItemList/PurchaseItemList';
import Spinner from 'components/Spinner';

let TransferLineItemForm = ({
  handleSubmit,
  error,
  from,
  to,
  purchase,
  lineItemsPage,
  loading,
}) => (
  <form
    onSubmit={handleSubmit}
    className="flex-align-center flex-direction-column relative"
  >
    <PurchaseItemList
      purchase={purchase}
      items={from.line_items}
      lineItemsPage={lineItemsPage}
      title="Transfer Line Items"
      pageBaseUrl={`/purchases/${from.id}/transfer-line-items`}
      actionComponent={(line) => (
        <Field
          component={CheckboxField}
          name={`line_${line.id}`}
          label="Transfer"
          type="checkbox"
        />
      )}
    />

    {error && (
      <div className="mar-t">
        <FormError error={error} />
      </div>
    )}

    <Spinner showLoader={loading} />

    <button className="btn btn-danger" type="submit" disabled={!to}>
      Transfer Selected Lines
    </button>
  </form>
);

TransferLineItemForm = reduxForm({
  form: 'transferLineItem',
})(TransferLineItemForm);

export default TransferLineItemForm;
